import { render, staticRenderFns } from "./SimpleCarousel.vue?vue&type=template&id=2163d2d8&scoped=true"
import script from "./SimpleCarousel.vue?vue&type=script&lang=js"
export * from "./SimpleCarousel.vue?vue&type=script&lang=js"
import style0 from "./SimpleCarousel.vue?vue&type=style&index=0&id=2163d2d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2163d2d8",
  null
  
)

export default component.exports